import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from './menu'
import errores from '../middleware/errordb'
import back from '../back.svg';
import config from '../config';
import funciones from '../middleware/funciones';
import Mensajes from './subcomponent/mensajes';
import ModalConfirm from './subcomponent/modalConfirm';

class FormularioResolucion extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Resolucion",
            msg: 0,
            comp: "",
            id_resolucion: "",
            empresa: currentCompany,
            codEmp: "",
            resolucion: "",
            fecha_resolucion: "",
            prefijo: "",
            tipo_documento: "",
            consecutivo_inicio: "",
            consecutivo_fin: "",
            fecha_inicial: "",
            fecha_final: "",
            punto_venta: "",
            tipo_aprobacion: "",
            tipo: currentUserType,
            mostrarMensaje: false,
            consecutivo_actual: 0,
            mensaje: "",
            contingencia: "01"
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_resolucion = "";
        const resolucionEdicion = search.replace('?', '');
        if (resolucionEdicion) {
            titulo = "Modificar Resolucion";
            id_resolucion = resolucionEdicion;
            const datasend = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/resoluciones/' + resolucionEdicion, datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        this.setState({
                            codEmp: datos[0]["CODIGO_EMPRESA"],
                            resolucion: datos[0]["RESOLUCION"],
                            fecha_resolucion: datos[0]["FECHA_RESOLUCION"],
                            prefijo: datos[0]["PREFIJO"],
                            tipo_documento: datos[0]["TIPO_DOCUMENTO"],
                            consecutivo_inicio: datos[0]["CONSECUTIVO_INICIO"],
                            consecutivo_fin: datos[0]["CONSECUTIVO_FIN"],
                            fecha_inicial: datos[0]["FECHA_INICIAL"],
                            fecha_final: datos[0]["FECHA_FINAL"],
                            punto_venta: datos[0]["PUNTO_VENTA"],
                            tipo_aprobacion: datos[0]["TIPO_APROBACION"],
                            contingencia: datos[0]["CONTINGENCIA"],
                            consecutivo_actual: datos[0]["CONSECUTIVO_ACTUAL"]
                        });
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: data.message })
                    }
                });
        } else {
            titulo = "Crear Resolucion";
            id_resolucion = "";
        }
        this.setState({ id_resolucion, titulo });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        const { empresa } = this.state
        const { codEmp } = this.state
        const { resolucion } = this.state
        const { fecha_resolucion } = this.state
        const { prefijo } = this.state
        const { tipo_documento } = this.state
        const { consecutivo_inicio } = this.state
        const { consecutivo_fin } = this.state
        const { fecha_inicial } = this.state
        const { fecha_final } = this.state
        const { punto_venta } = this.state
        const { tipo_aprobacion } = this.state
        const { contingencia } = this.state
        const { consecutivo_actual } = this.state

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                codEmp,
                resolucion,
                fecha_resolucion: funciones.formatDate(fecha_resolucion),
                prefijo,
                tipo_documento,
                consecutivo_inicio,
                consecutivo_fin,
                fecha_inicial: funciones.formatDate(fecha_inicial),
                fecha_final: funciones.formatDate(fecha_final),
                punto_venta,
                tipo_aprobacion,
                contingencia,
                consecutivo_actual
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_resolucion === "") {
            ruta = config.servBackEnd + '/resoluciones/create';
        } else {
            ruta = config.servBackEnd + '/resoluciones/modify/' + this.state.id_resolucion;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevaResolucion = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_resolucion;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_resolucion: nuevaResolucion })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Resolucion con errores:" + errores[data.code] +" " + data.message })
                }
            });
        event.preventDefault();
    }

    changeTypeDocument=({target})=>{
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        //console.log(target.value);
        this.setState({
            tipo_documento:target.value,
            resolucion: 0,
            fecha_resolucion: todayFormat,
            fecha_inicial: todayFormat,
            fecha_final: todayFormat
        });
    }
    handleClose = () => {
        this.setState({show: false});
    };

    render() {
        const mensajeBoton = (this.state.id_resolucion === "") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_resolucion === "") ? '¿Esta seguro que desea crear la resolución?' : '¿Esta seguro que desea modificar la resolución?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        return (
            <div className="FormularioResolucion">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Resoluciones!</Tooltip>}>
                            <div className="div-back">
                                <a href="/resoluciones/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Tipo Documento</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={this.changeTypeDocument} value={this.state.tipo_documento} required>
                                                <option value="">-- Seleccione --</option>
                                                <option value="FV">Factura</option>
                                                <option value="NC">Nota Credito</option>
                                                <option value="ND">Nota Debito</option>
                                                <option value="PE">Pedido</option>
                                                <option value="PS">Post</option>
                                                <option value="NE">Nomina Electronica</option>
                                                <option value="NA">Nomina Electronica Ajuste</option>
                                                <option value="DS">Documento Soporte</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Resolucion</Form.Label>
                                            <Form.Control type="text" placeholder="Resolucion" onChange={e => this.setState({ resolucion: e.target.value.toUpperCase() })} value={this.state.resolucion} disabled={this.state.tipo_documento==="PE" } required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Prefijo</Form.Label>
                                            <Form.Control type="text" placeholder="Prefijo" onChange={e => this.setState({ prefijo: e.target.value.toUpperCase() })} value={this.state.prefijo} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Consecutivo Inicio</Form.Label>
                                            <Form.Control type="number" placeholder="1" onChange={e => this.setState({ consecutivo_inicio: e.target.value, consecutivo_actual: e.target.value })} value={this.state.consecutivo_inicio} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Consecutivo Fin</Form.Label>
                                            <Form.Control type="number" placeholder="9999999" onChange={e => this.setState({ consecutivo_fin: e.target.value })} value={this.state.consecutivo_fin} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Fecha Inicial</Form.Label>
                                            <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value, fecha_resolucion: e.target.value })} disabled={this.state.tipo_documento==="PE" } value={funciones.formatDate(this.state.fecha_inicial)} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Fecha Final</Form.Label>
                                            <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} disabled={this.state.tipo_documento==="PE" } value={funciones.formatDate(this.state.fecha_final)} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Consecutivo Actual</Form.Label>
                                            <Form.Control type="number" placeholder="1" onChange={e => this.setState({ consecutivo_actual: e.target.value })} value={this.state.consecutivo_actual} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Tipo Aprobacion</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ tipo_aprobacion: e.target.value })} disabled={this.state.tipo_documento==="PE" } value={this.state.tipo_aprobacion} required>
                                                <option value="">-- Seleccione --</option>
                                                <option value="Habilitada">HABILITADA</option>
                                                <option value="Autorizada">AUTORIZADA</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Factura Contingencia</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ contingencia: e.target.value })} disabled={this.state.tipo_documento==="PE" } value={this.state.contingencia} required>
                                                <option value="03">SI</option>
                                                <option value="01">NO</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Punto De Venta</Form.Label>
                                            <Form.Control type="number" placeholder="Tipo Documento" onChange={e => this.setState({ punto_venta: e.target.value })} disabled={this.state.tipo_documento==="PE" } value={this.state.punto_venta} required />
                                        </Form.Group>

                                    </Form.Row>

                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (FormularioResolucion);